import {Component} from "react";
import * as React from "react";

import moment from "moment";
import {Line} from "react-chartjs-2";
import {WorkloadStats} from "../models/WorkloadAnalytics";
import * as _ from "lodash";
import { IDropdownOption } from "office-ui-fabric-react";
import { Dropdown } from "office-ui-fabric-react/lib-commonjs";

export const LINE_CHART_OPTIONS = {
    scales: {
        xAxes: [{
            gridLines: {
                drawOnChartArea: false,
            },
            ticks: {
                padding: 5
            },
            type: 'time',
            time: {
                unit: 'day'
            }
        }]
    }
};

const WORKLOAD_STATS_PROPERTY_NAMES = [
    "allStatusAverageRunTime",
    "allStatusCount",
    
    "completedAverageRunTime",
    "completedCount",
    "completedPercentage",
    
    "failedAverageRunTime",
    "failedCount",
    "failedPercentage",
    
    "terminatedAverageRunTime",
    "terminatedCount",
    "terminatedPercentage"
];

interface WorkloadStatsOverTimeCardProps
{
    selectedWorkloadName?: string;
    workloadStats: WorkloadStats[];
}

interface WorkloadStatsOverTimeCardState
{
    data?: object;
    statPropertyNameOptions: IDropdownOption[];
    selectedStatPropertyName: string;
}

export default class WorkloadStatsOverTimeCard extends Component<WorkloadStatsOverTimeCardProps,WorkloadStatsOverTimeCardState>
{
    constructor(props: Readonly<WorkloadStatsOverTimeCardProps>) {
        super(props);

        
        const statPropertyNameOptions: IDropdownOption[] = WORKLOAD_STATS_PROPERTY_NAMES.map(propName => {
            return {key: propName,text: propName, data: propName};
        })
        
        this.state = {
            data: {},
            selectedStatPropertyName: "completedPercentage",
            statPropertyNameOptions
        }
    }

    public componentDidMount() {
        if(this.props.workloadStats && this.props.selectedWorkloadName)
        {
            this.setData();
        }
    }


    componentDidUpdate(prevProps: Readonly<WorkloadStatsOverTimeCardProps>, prevState: Readonly<WorkloadStatsOverTimeCardState>, snapshot?: any): void {
        if(this.props.workloadStats !== prevProps.workloadStats || this.props.selectedWorkloadName !== prevProps.selectedWorkloadName || this.state.selectedStatPropertyName !== prevState.selectedStatPropertyName)
        {
            this.setData();
        }
    }

    private setData()
    {
        const groupedWorkloadStats = _.groupBy(this.props.workloadStats,"workloadName");
        let labels: any[] = _.uniq(_.map(this.props.workloadStats,s=> s.date));
        labels = _.map(labels,l => moment(l).toDate());

        const datasets = _.map(_.keys(groupedWorkloadStats),(workloadName) =>
        {
            const workloadStats = groupedWorkloadStats[workloadName];

            const data = _.map(workloadStats, s => {
                return s[this.state.selectedStatPropertyName];
            });

            return {
                label: workloadName,
                data: data
            };
        });

        const data = {
            title: "Title Here",
            labels: labels,
            datasets: _.filter(datasets, d => d.label === this.props.selectedWorkloadName)
        };

        this.setState({
            data
        });
    }

    private onOptionSelected = (event: any,option?: IDropdownOption) => {
        if(!option)
        {
            return;
        }

        this.setState({
            selectedStatPropertyName: option.data
        });
    };

    public render() {

        if(this.state.data === undefined)
        {
            return null;
        }
        
        return (
            <div className={"card flex-item--flex-1"}>
                
                <div className={"card__header"}>
                        <div className="card__title">
                            {this.props.selectedWorkloadName} Performance<br/>
                            <span className={"text-extra-detail"}>{this.state.selectedStatPropertyName} over time</span>
                        </div>
                    
                    <Dropdown
                        className={"p-right-1rem"}
                        onChange={this.onOptionSelected}
                        selectedKey={this.state.selectedStatPropertyName}
                        placeholder={"Select Stat"}
                        options={this.state.statPropertyNameOptions}
                        styles={{ dropdown: { width: 300 } }}
                    />
                </div>
                <div className={"card__content"}>
                    <Line data={this.state.data} options={LINE_CHART_OPTIONS} width={6} height={1}/>
                </div>

            </div>
        );

    }
}